import React, { useState, useEffect, useRef } from "react";
import DashBoardTable from "../ProGridTable/DashBoardTable";
import { getApi } from '../../../../utils/services'
import { JTA_AVERAGE_GAUGE_PROJECT_DATA } from '../../../../utils/services/apiPath'
import { roundToTwoDecimals } from "../../../../utils/formHelper";

const JtaAverageTable = ({ selectedProjectsQuery }) => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const hasFetchedData = useRef(false);
  const columns = [
    { field: "projectName", headerName: "Project" },
    { field: "otjHours", headerName: "Total OTJ Hours" },
    { field: "apprenticeHours", headerName: "Total Apprentice Hours" },
    { field: "lostOtj", headerName: "Total Lost OTJ" },
    { field: "totalHours", headerName: "Total Labor Hours" },
    { field: "jToA", headerName: "Journey to Apprentice Ratio" },
    { field: "apprenticeCount", headerName: "Total Apprentice Count" },
    { field: "mentorCount", headerName: "Total Mentor Count" },
    { field: "totalLaborCount", headerName: "Total Labor Count" },
  ];

  const fetchJtaAverageData = async () => {
    setLoading(true);
    try {
      const { data, error } = await getApi(`${JTA_AVERAGE_GAUGE_PROJECT_DATA}?projectIds=${selectedProjectsQuery}`);
      if (error) { throw new Error(error); }

      const rowsWithId = data.map((item, index) => ({
        id: `row-${index}`,
        projectName: item.projectName,
        otjHours: roundToTwoDecimals(item.otjHours),
        apprenticeHours: roundToTwoDecimals(item.apprenticeHours),
        lostOtj: roundToTwoDecimals(item.lostOtj),
        totalHours: roundToTwoDecimals(item.totalHours),
        jToA: roundToTwoDecimals(item.jToA),
        apprenticeCount: roundToTwoDecimals(item.apprenticeCount),
        mentorCount: roundToTwoDecimals(item.mentorCount),
        totalLaborCount: roundToTwoDecimals(item.totalLaborCount),
      }));
      setRows(rowsWithId);
    }
    finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (!hasFetchedData.current) {
      hasFetchedData.current = true;
      fetchJtaAverageData();
    }
  }, [selectedProjectsQuery]);


  return (
    <div style={{ margin: "20px" }}>
      <DashBoardTable
        columns={columns}
        rows={rows}
        loading={loading}
        paginationModel={{ page: 0, pageSize: 5 }}
        hideExport={false}
        checkboxSelection={false}
      />
    </div>
  );
};

export default JtaAverageTable;
